import { NavItem } from '@tran-monorepo/interfaces';

export const HOME_SECONDARY_NAVIGATION: NavItem[] = [
    { label: 'home.secondary-navigation.overview', route: 'overview' },
    { label: 'home.secondary-navigation.about', route: 'about' },
    { label: 'home.secondary-navigation.how-to-apply', route: 'how-to-apply' },
    { label: 'home.secondary-navigation.dates-deadlines', route: 'dates-deadlines' }
];
